import '@hotwired/turbo-rails'
import { Application } from '@hotwired/stimulus'
import DynamicFormController from '../controllers/dynamic_form_controller.js'
import KeyboardPreviewController from '../controllers/keyboard_preview_controller.js'
import NumberStepperController from '../controllers/number_stepper_controller.js'
import SelectController from '../controllers/select_controller.js'
import './application.css'

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application
application.register('dynamic-form', DynamicFormController)
application.register('keyboard-preview', KeyboardPreviewController)
application.register('number-stepper', NumberStepperController)
application.register('select', SelectController)
